import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, Route, Router, Switch } from "react-router-dom";
import { LoginAppShell } from "./app/layouts/app-shell-login";
import { createBrowserHistory } from "history";
import AppShell from "./app/layouts/app-shell";
import "./app/assets/main.css";
import Amplify, { Auth } from "aws-amplify";
import AgentForm from "./features/agent-management/form/agent-form";
import AgentsDashboard from "./features/agent-management/list/agents-dashboard";
import { Login } from "./features/login/signin-form";
import { SetNewPassword } from "./features/login/complete-new-password-form";
import  ExchangeRateForm  from "./features/exchange-rates-management/form/exchange-rate-form";
import ExchangeRatesList from "./features/exchange-rates-management/list/exchange-rates-list";
import { amplifySettings } from "./app/api/amplify-settings";
import  AdminDashboard  from "./features/dashboards/dashaboard";
import OrderForm from '../src/features/orders/form/order-form';
import OrdersSearch  from "./features/orders/list/orders-search";
import Dashboard from "./features/dashboards/dashaboard";
import SupportTicketForm from "./features/support-tickets/form/support-ticket-form";
import ForgotPasswordForm from "./features/login/forgot-password-form";
import ForgotPasswordSubmitForm from "./features/login/forgot-password-submit-form";
import PayBalanceForm from "./features/orders/balance/pay-balance-form";
import OrderFormContainer from "./features/orders/form/order-form-container";
import InvoicePrintContainer from "./features/dashboards/invoice/invoice-print-container";
import InvoicePage from "./features/dashboards/invoice/invoice-page";
import OrdersExportContainer from "./features/export/orders-export-container";


export const history = createBrowserHistory();
Amplify.configure(amplifySettings);
ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Switch>
        <Route path="/confirm">
          <LoginAppShell>
            <SetNewPassword />
          </LoginAppShell>
        </Route>
        <Route path="/signIn">
          <LoginAppShell>
            <Login />
          </LoginAppShell>
        </Route>
        <Route path="/agents/create">
          <AppShell>
            <AgentForm />
          </AppShell>
        </Route>

        <Route path="/agents/edit/:id">
          <AppShell>
            <AgentForm />
          </AppShell>
        </Route>
        <Route path="/agents">
          <AppShell>
            <AgentsDashboard />
          </AppShell>
        </Route>        
        <Route path="/rates/edit/:id">
          <AppShell>
            <ExchangeRateForm/>
          </AppShell>
        </Route>
        <Route path="/rates/create">
          <AppShell>
            <ExchangeRateForm />
          </AppShell>
        </Route>
        <Route path="/rates">
          <AppShell>
            <ExchangeRatesList />
          </AppShell>
        </Route>
        <Route path="/invoice">
          <AppShell>
            <InvoicePage/>
          </AppShell>
        </Route>
        <Route path="/orders/export">
          <AppShell>
            <OrdersExportContainer/>
          </AppShell>
        </Route>
        <Route path="/orders/edit/:orderId">
          <AppShell>
            <OrderFormContainer/>
          </AppShell>
        </Route>
        <Route path="/orders/create">
          <AppShell>
           <OrderFormContainer/>
          </AppShell>
        </Route>
        <Route path="/orders/balance">
          <AppShell>
            <PayBalanceForm/>
          </AppShell>
        </Route>
        <Route path="/orders">
          <AppShell>
           <OrdersSearch/>
          </AppShell>
        </Route>
        <Route path="/tickets/edit/:id">
          <AppShell>
            <SupportTicketForm/>
          </AppShell>
        </Route>
        <Route path="/tickets/create/:id">
          <AppShell>
            <SupportTicketForm/>
          </AppShell>
        </Route>
        <Route path="/forgot">
          <LoginAppShell>
            <ForgotPasswordForm/>
          </LoginAppShell>
        </Route>
        <Route path="/reset">
          <LoginAppShell>
            <ForgotPasswordSubmitForm/>
          </LoginAppShell>
        </Route>
        <Route path="/">
          <AppShell>
            <Dashboard/>
          </AppShell>
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
